import { connectedRouterRedirect } from 'redux-auth-wrapper/history3/redirect';
import locationHelperBuilder from 'redux-auth-wrapper/history3/locationHelper'
import { routerActions } from 'react-router-redux';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { apiCallIds } from '../api';
import { selectAccount } from '../ducks';

const locationHelper = locationHelperBuilder({});

export default connectedRouterRedirect({
  authenticatedSelector: state => selectAccount(state) === null,
  authenticatingSelector: state => selectIsInProgress(state, apiCallIds.LOGIN),
  redirectPath: (_, ownProps) => locationHelper.getRedirectQueryParam(ownProps) || '/',
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'LoginWrapper',
  allowRedirectBack: false,
});



// WEBPACK FOOTER //
// ./src/features/auth/utils/LoginWrapper.js